import Image from 'next/image';

import useFallbackTranslation from '../../utils/hooks/useFallbackTranslation';

export const LogoLink = () => {
  const { getURLWithLocalePrefix, t } = useFallbackTranslation();

  return (
    <div className="flex items-center">
      <a
        href={getURLWithLocalePrefix('/')}
        className="mr-auto flex h-10 w-fit min-w-[150px] justify-start self-center text-xs"
      >
        {/* src speicified with `require` to dynamically resolve svg path in next application */}
        <Image
          className="w-auto"
          width="600"
          height="200"
          alt={t('topmenu.JabraLogo')}
          src={require(`./images/jabra-logo.svg?url`)}
          aria-label={t('topmenu.JabraLogo')}
        />
      </a>
    </div>
  );
};
